import { DocumentModel } from './document-model'

export class DocumentsResponseModel {
  total_results: number
  current_page: number
  total_pages: number
  next_page: string
  prev_page: string
  limit: number
  rows: DocumentModel[]

  constructor(response) {
    {
      this.total_results = response.pagination.total_results
      this.current_page = response.pagination.current_page
      this.total_pages = response.pagination.total_pages
      this.next_page = response.pagination.next_page
      this.prev_page = response.pagination.prev_page
      this.limit = response.pagination.limit

      this.rows = response.rows.map(document => {
        return new DocumentModel(document)
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/main/content/ledger/models/documents-response.model.ts